import { createAction } from '@reduxjs/toolkit';

/** Signal actions: intents for the saga (side effects, not state transitions). */

/** Load the current user's cookies (dispatched on mount). */
export const loadRequested = createAction('linkedinCookies/loadRequested');

/** Persist the current draft cookies (dispatched on Save). */
export const saveRequested = createAction('linkedinCookies/saveRequested');
